import { Table, Icon } from "antd";
import { withTheme } from "styled-components";
import moment from "moment";
import React, { Component } from "react";
import styled from "styled-components";

import { CallChannelKeys } from "../../../util/appointments";
import { Container, Title } from "./style";
import ColorUtil from "../../../util/ColorUtil";
import EmptyModal from "../../modal/EmptyModal";

class TableUserSessions extends Component {
    state = {}

    renderTable = (props = {}, renderPerPage = null) => {
    	const { employee_sessions, theme, visualColorKey } = this.props;
    	const color = ColorUtil.getVisualizeColor(theme, visualColorKey, 0, 1);
    	const sessions = employee_sessions ?
    		employee_sessions.map((value, index) => {
    			const sessionStart = moment.unix(value.start);
    			const sessionEnd = moment.unix(value.end);
    			const duration = sessionEnd.diff(sessionStart, "minutes");
    			value.key = index;
    			value.duration = `${duration} minutes`;
    			value.date = moment.unix(value.start).format("DD/MM/YYYY");
    			value.time = moment.unix(value.start).format("HH:mm");
    			return value;
    		}).sort((a, b) => (b.start - a.start)) : [];
    	return (
    		<Table columns={columns(color)}
    			dataSource={renderPerPage && sessions.length > 0 ?
    				sessions.slice(0, renderPerPage) : sessions} size="middle"
    			pagination={false}
    			title={() => <Title>User sessions</Title>}
    			footer={() => employee_sessions && employee_sessions.length > 4 && <a
    				style={{ color }}
    				onClick={() => this.refs.modal.showModal()}>Load more</a>}
    			{...props} />
    	);
    }

    render() {
    	return (
    		<Container>
    			{this.renderTable({}, 4)}
    			<EmptyModal ref='modal' title="User sessions">
    				{this.renderTable({ footer: null, title: null, pagination: true })}
    			</EmptyModal>
    		</Container>
    	);
    }
}

export default withTheme(TableUserSessions);


const columns = (color) => [{
	title: <div style={{ fontSize: 12, color }}>Sessions</div>,
	render: (text, record, index) => <Icon style={{ color }}
		type={text === CallChannelKeys.WEB ? "video-camera" : "customer-service"} />,
	dataIndex: "session",
}, {
	title: <div style={{ fontSize: 12, color }}>Duration</div>,
	render: (text, record, index) => <div style={{ fontSize: 12 }}>{text}</div>,
	dataIndex: "duration",
}, {
	title: <div style={{ fontSize: 12, color }}>Date</div>,
	render: (text, record, index) => <div style={{ fontSize: 12 }}>{text}</div>,
	dataIndex: "date",
}, {
	title: <div style={{ fontSize: 12, color }}>Time</div>,
	render: (text, record, index) => <div style={{ fontSize: 12 }}>{text}</div>,
	dataIndex: "time",
}, {
	title: <div style={{ fontSize: 12, color }}>Provider</div>,
	render: (text, record, index) => <div style={{ fontSize: 12 }}>{text}</div>,
	dataIndex: "provider",
}];

const data = [
	{
		key: 1,
		sessions: CallChannelKeys.WEB,
		duration: "30 minutes",
		date: "14/01/2018",
		time: "10:00",
		provider: "Dr.Jane Smith",
	},
	{
		key: 2,
		sessions: CallChannelKeys.PHONE,
		duration: "30 minutes",
		date: "10/01/2018",
		time: "08:15",
		provider: "Dr.John Doe",
	},
];


// WEBPACK FOOTER //
// ./src/components/report/individual_user/TableUserSessions.js